/* eslint-disable no-use-before-define */
import Yup from '../../i18n/yup'

// no cambiar el orden / se dana todo =(
const SPEED_LIMIT_OPTIONS = [
  { value: '0', label: 'Sin limite' },
  { value: '1024', label: '1 Mbps' },
  { value: '3072', label: '3 Mbps' },
  { value: '5120', label: '5 Mbps' },
  { value: '10240', label: '10 Mbps' },
  { value: '20480', label: '20 Mbps' },
];

function getLowerBoundSpeed(reqSpeed) {
  const speed = parseInt(reqSpeed, 10);
  for (const { value } of SPEED_LIMIT_OPTIONS.slice().reverse()) {
    if (value <= speed) return value;
  }
  return SPEED_LIMIT_OPTIONS[0].value;
}

export const requestToFormData = data => {
  const getRules = (rules, prefix = '') => {
    const defaultRules = [
      ...appCheckboxesData.map(o => o.id),
      ...webPagesCategoriesCheckboxesData.map(o => o.id),
      ...appCategoriesCheckboxesData.map(o => o.id)
    ]
    const currentRules = rules.map(r => r.name)

    return defaultRules.reduce((acc, dr) => ({
      ...acc,
      [dr.concat(prefix)]: currentRules.includes(dr)
    }), {})
  }

  const { guest, employee } = data
  let currentEmployee = {}

  if (employee) {
    currentEmployee = {
      password: employee.password,
      passwordConfirmation: employee.password,
      withPassword: true,
      'ssid-withpwd': employee.ssid,
      'limitUp-withpwd': getLowerBoundSpeed(employee.limitUp),
      'limitDown-withpwd': getLowerBoundSpeed(employee.limitDown),
      ...getRules(employee.rules, '-withpwd')
    }
  }

  return {
    ssid: guest.ssid,
    limitUp: getLowerBoundSpeed(guest.limitUp),
    limitDown: getLowerBoundSpeed(guest.limitDown),
    ...getRules(guest.rules),
    ...currentEmployee
  }
}

const infoToRules = (info, type, values) => info.filter(
  checkbInfo => values[checkbInfo.id],
).map(checkbInfo => ({
  name: checkbInfo.id,
  type,
  action: 'deny',
}));

const removePrefixFromRulesWithPass = (values) => {
  const rules = infoToRules(withPasswordAppCheckboxesData, 'app', values).concat(
    infoToRules(withPasswordAppCategoriesCheckboxesData, 'app_category', values).concat(
      infoToRules(withPasswordWebPagesCategoriesCheckboxesData, 'web_category', values),
    ),
  )

  return rules.map(r => ({ ...r, name: r.name.replace('-withpwd', '') }))
}

export const formToRequestData = values => {
  const redWithPass = values.withPassword ? {
    ssid: values['ssid-withpwd'],
    limitDown: values['limitDown-withpwd'],
    limitUp: values['limitUp-withpwd'],
    rules: removePrefixFromRulesWithPass(values),
    password: values.password,
  } : undefined

  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      redWithPass,
      red: {
        ssid: values.ssid,
        limitDown: values.limitDown,
        limitUp: values.limitUp,
        rules: infoToRules(appCheckboxesData, 'app', values).concat(
          infoToRules(appCategoriesCheckboxesData, 'app_category', values).concat(
            infoToRules(webPagesCategoriesCheckboxesData, 'web_category', values),
          ),
        ),
      },
    })
  }
};

export const baseUrl = `${process.env.REACT_APP_API_URL}/network/guest`;

const commonValidationSchema = {
  ssid: Yup.string().min(3).max(255),
  limitDown: Yup.string(),
  limitUp: Yup.string(),
}

export const validationSchema = Yup.object().shape(
  Object
    .entries(commonValidationSchema)
    .reduce((acc, [k, schema]) =>
    ({
      ...acc,
      [k]: schema.required(),
      [`${k}-withpwd`]: schema.when('withPassword', {
        is: true,
        then: schema.required(),
        otherwise: schema,
      })
    }),
      {
        password: Yup.string().min(8).matches(/^[ -~]+$/, 'NETWORK.FORM_VALIDATION.INVALID_PASSWORD')
          .when('withPassword', (withPassword, schema) => {
            return withPassword ? schema.required() : schema
          }),
        passwordConfirmation: Yup.string().oneOf([Yup.ref('password')], 'NETWORK.FORM_VALIDATION.PASSWORD_CONFIRMATION')
          .when('withPassword', (withPassword, schema) => {
            return withPassword ? schema.required() : schema
          }),
      }
    )
)

export const baseInputsData = [
  {
    id: 'ssid',
    title: 'NETWORK.BASE_INPUTS.SSID',
    type: 'text',
    iconName: 'name',
  }
];

export const bandwidthInputsData = [
  {
    id: 'limitDown',
    title: 'NETWORK.BASE_INPUTS.LIMIT_DOWN',
    type: 'select',
    options: SPEED_LIMIT_OPTIONS,
    iconName: 'minimum',
  },
  {
    id: 'limitUp',
    title: 'NETWORK.BASE_INPUTS.LIMIT_UP',
    type: 'select',
    options: SPEED_LIMIT_OPTIONS,
    iconName: 'maximum',
  },
];

export const getAppCheckboxesData = (isFacebookEnabled = true) => [
  {
    id: 'instagram',
    title: 'Instagram',
    type: 'checkbox',
  },
  {
    id: 'netflix',
    title: 'Netflix',
    type: 'checkbox',
  },
  {
    id: 'spotify',
    title: 'Spotify',
    type: 'checkbox',
  },
  {
    id: 'facebook',
    title: 'Facebook',
    type: 'checkbox',
    disabled: !isFacebookEnabled,
  },
  {
    id: 'whatsapp',
    title: 'Whatsapp',
    type: 'checkbox',
  },
  {
    id: 'youtube',
    title: 'Youtube',
    type: 'checkbox',
  },
];

export const appCheckboxesData = getAppCheckboxesData()

export const appCategoriesCheckboxesData = [{
  id: 'Streaming',
  title: 'Streaming',
  type: 'checkbox',
}];

export const webPagesCategoriesCheckboxesData = [
  {
    id: 'Adult and Pornography',
    title: 'NETWORK.CATEGORIES_CHECKBOXES.ADULT_CONTENT',
    type: 'checkbox',
  },
  {
    id: 'Games',
    title: 'NETWORK.CATEGORIES_CHECKBOXES.GAMES',
    type: 'checkbox',
  },
  {
    id: 'Abused Drugs',
    title: 'NETWORK.CATEGORIES_CHECKBOXES.DRUGS',
    type: 'checkbox',
  },
  {
    id: 'Weapons',
    title: 'NETWORK.CATEGORIES_CHECKBOXES.WEAPONS',
    type: 'checkbox',
  },
];

const cloneWithPostfix = arr =>
  arr.map(data => ({ ...data, id: `${data.id}-withpwd` }));


export const withPasswordCheckbox = [
  {
    id: 'withPassword',
    title: 'NETWORK.ENABLE_PASSWORD',
    type: 'switch',
    marginBottom: '40px',
  },
];

export const withPasswordBaseInputsData = [
  {
    id: 'ssid-withpwd',
    title: 'NETWORK.BASE_INPUTS.SSID_WITH_PWD',
    type: 'text',
    iconName: 'name',
    titleTop: (value, isFocused, isMobile) => isMobile ? value || isFocused ? '-35px' : '5px' : null,
  }
];

export const withPasswordBandwidthInputsData = [
  {
    id: 'limitDown-withpwd',
    title: 'NETWORK.BASE_INPUTS.LIMIT_DOWN',
    type: 'select',
    options: SPEED_LIMIT_OPTIONS,
    iconName: 'minimum',
  },
  {
    id: 'limitUp-withpwd',
    title: 'NETWORK.BASE_INPUTS.LIMIT_UP',
    type: 'select',
    options: SPEED_LIMIT_OPTIONS,
    iconName: 'maximum',
  },
  {
    id: 'password',
    title: 'NETWORK.PASSWORD_PLACEHOLDER',
    type: 'password',
    iconName: 'lock',
    hasShowPasswordButton: true,
  },
  {
    id: 'passwordConfirmation',
    title: 'NETWORK.PASSWORD_CONFIRMATION_PLACEHOLDER',
    type: 'password',
    iconName: 'lock',
    hasShowPasswordButton: true,
  },
];

export const withPasswordAppCheckboxesData = cloneWithPostfix(appCheckboxesData);
export const withPasswordAppCategoriesCheckboxesData =
  cloneWithPostfix(appCategoriesCheckboxesData);
export const withPasswordWebPagesCategoriesCheckboxesData =
  cloneWithPostfix(webPagesCategoriesCheckboxesData);


export const initialValues = {
  ssid: 'eswd',
  limitUp: '54',
  limitDown: '128',
  instagram: true,
  netflix: true,
  spotify: true,
  facebook: true,
  whatsapp: true,
  youtube: true,
  Streaming: true,
  'Adult and Pornography': false,
  Games: true,
  'Abused Drugs': false,
  Weapons: true,
  withPassword: false,
};
